export function loadWithVxeTable(task) {
    return Promise.all([
        task(),
        import(/* webpackChunkName: "vxe-table" */ '@/constants/initVxeTable'),
    ]).then(([data]) => {
        return data;
    });
}
